import React from 'react'
import {IconButton, Slide, Snackbar, SnackbarContent} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const color = {success: '#8bc34a', error: '#ff1744', warning: '#ffc107'}

/**
 * @param: msg (msgLv, msg), close, open
 */
export function MsgIcon(props) {
    const msgLv = props.msgLv;
    switch (msgLv) {
        case 'success':
            return <CheckCircleOutlineIcon/>;
        case 'warning':
            return <WarningAmberIcon/>;
        case 'error':
            return <ErrorOutlineIcon/>;
        default:
            return <HelpOutlineIcon />;
    }
}

export default function ShowSnackbar(props) {
    const {msgLv, msg} = props.msg;

    const handleAlertClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        props.close({open: false, msg: '', msgLv: ''});
    }

    const snackbarAction = (
        <>
            <IconButton
                size='small'
                aria-label='close'
                color='inherit'
                onClick={handleAlertClose}
            >
                <CloseIcon fontSize='small'/>
            </IconButton>
        </>
    )

    return (
        msgLv && msg &&
        <Snackbar open={props.open}
                  autoHideDuration={8000}
                  anchorOrigin={{vertical:"bottom", horizontal: "center"}}
                  onClose={handleAlertClose}
                  TransitionComponent={Slide}
        >
            <SnackbarContent action={snackbarAction}
                             sx={{backgroundColor: `${color[msgLv]}`, fontSize: '16px', color: 'black'}}
                             message={<Box display='flex'
                                           alignItems='center'>
                                 <MsgIcon msgLv={msgLv}/>&nbsp;{msg}
                             </Box>}
            />
        </Snackbar>
    )

}
